"use client";

import { cn } from "@/lib/utils";

interface UserAvatarProps {
  nombre: string;
  fotoUrl?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

function getInitials(nombre: string): string {
  const parts = nombre.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getAvatarColor(nombre: string): string {
  const colors = [
    "bg-blue-600",
    "bg-indigo-600",
    "bg-violet-600",
    "bg-teal-600",
    "bg-emerald-600",
    "bg-orange-600",
  ];
  let hash = 0;
  for (let i = 0; i < nombre.length; i++) {
    hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}

export function UserAvatar({ nombre, fotoUrl, size = "md", className }: UserAvatarProps) {
  const sizeClass =
    size === "sm" ? "size-7 text-[10px]" :
    size === "lg" ? "size-20 text-2xl" :
    "size-8 text-[11px]";

  if (fotoUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={fotoUrl}
        alt={`Foto de ${nombre}`}
        className={cn("rounded-full object-cover shrink-0", sizeClass, className)}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={cn(
        "rounded-full flex items-center justify-center shrink-0 font-semibold text-white select-none",
        getAvatarColor(nombre),
        sizeClass,
        className,
      )}
    >
      {getInitials(nombre)}
    </span>
  );
}
